import React, { useEffect, useRef } from 'react';

interface LandingPageIframeProps {
  url: string;
  onClose: () => void;
}

export const LandingPageIframe: React.FC<LandingPageIframeProps> = ({ url, onClose }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!iframeRef.current || event.source !== iframeRef.current.contentWindow) return;
      // SET_HEIGHT is only posted in design mode; code 1003 ({action:'height'})
      // is the runtime auto-height contract. With embedMode=inner the landing
      // scrolls itself and posts neither — this is a fallback for older landing
      // deployments that ignore embedMode and disable their internal scroll.
      const height =
        event.data?.type === 'SET_HEIGHT' ? event.data.payload
        : event.data?.code === 1003 ? event.data.value
        : null;
      if (typeof height === 'number' && height > 0) {
        iframeRef.current.style.height = `${height}px`;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="balance-iframe-container">
      <button className="balance-iframe-close" onClick={onClose}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0174 13.985L20.0277 21.9958C20.2947 22.2537 20.6524 22.3965 21.0237 22.3932C21.3949 22.39 21.7501 22.2411 22.0126 21.9785C22.2751 21.716 22.4241 21.3608 22.4273 20.9895C22.4305 20.6182 22.2878 20.2605 22.0299 19.9934L14.0196 11.9827L22.0299 3.97187C22.2878 3.7048 22.4305 3.34709 22.4273 2.9758C22.4241 2.60451 22.2751 2.24934 22.0126 1.98678C21.7501 1.72423 21.3949 1.5753 21.0237 1.57208C20.6524 1.56885 20.2947 1.71158 20.0277 1.96953L12.0174 9.98032L4.00724 1.96953C3.73898 1.71796 3.38337 1.58063 3.01567 1.5866C2.64796 1.59257 2.297 1.74138 2.03705 2.00153C1.7771 2.26168 1.62855 2.61277 1.62284 2.9805C1.61713 3.34824 1.75471 3.70377 2.00645 3.97187L10.0153 11.9827L2.00504 19.9934C1.8698 20.1241 1.76192 20.2803 1.68771 20.4531C1.6135 20.6259 1.57444 20.8117 1.57281 20.9997C1.57117 21.1877 1.607 21.3742 1.6782 21.5482C1.74939 21.7223 1.85453 21.8804 1.98749 22.0133C2.12044 22.1463 2.27853 22.2514 2.45255 22.3226C2.62657 22.3938 2.81303 22.4297 3.00104 22.428C3.18905 22.4264 3.37486 22.3873 3.54761 22.3131C3.72037 22.2389 3.87662 22.131 4.00724 21.9958L12.0174 13.985Z" fill="white"/>
        </svg>
      </button>
      <iframe
        ref={iframeRef}
        src={url}
        className="balance-iframe"
        title="Landing Page"
        allow="accelerometer; autoplay; camera; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};
